import React from "react";
import { IGOMAveragesListener } from "../../IGOMAveragesListener";
import { ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { IPlotToShow, TimeRange } from "../GOMCurrent/GOMCurrentPage";
import { createTheme } from "@mui/material";
import { DataProvider } from "../../Contexts/dataContext";
import { ChartSelector } from "./ChartSelector";
import { ProfileChartComponent } from "./ProfileChartComponent";
import { SpeedUnits } from "../SiteObservations/Current";

interface Props {
    liveDataListeners: ILiveDataListener[],
    GOMAveragesListeners: IGOMAveragesListener[],
    station: ParameterSchemaStation,
    timeRange: TimeRange,
    plots: IPlotToShow[],
    speedUnits: SpeedUnits,
    unitsStrDepthOrHeight: string,
    ucf_DepthOrHeight: (value: any) => any,
    speedUnitsStr: string,
    ucf_Speed: (value: any) => any,
}

export function ChartsComponent(props: Props): React.JSX.Element {

const theme = createTheme({ //: https://mui.com/material-ui/customization/typography/#font-size  +  https://mui.com/material-ui/customization/theme-components/#theme-variables
    typography: {
        fontSize: 20,
    },
});

const [chartTypeToShow, setChartTypeToShow] = React.useState<string>(props.plots[0].parameterGroup);

return (
    <div
        style={{
            position: 'absolute',
            height: '44.5em',//'47em',
            width: '30em',
            top: '60pt'
        }}
    >
        <DataProvider
            liveDataListeners={props.liveDataListeners}
            GOMAveragesListeners={props.GOMAveragesListeners}
            timeRange={props.timeRange}
        >
            {/* Chart selector */}
            {"Chart: "} 
            <ChartSelector
                plots={props.plots}
                chartTypeToShow={chartTypeToShow}
                setChartTypeToShow={setChartTypeToShow}
            />

            {/* Charts */}
            {props.plots.map((plot) => {

                    if (plot.parameterGroup == chartTypeToShow) {
                        return (
                            <ProfileChartComponent
                                station={props.station}
                                profileName={plot.profileName}
                                parameterGroup={plot.parameterGroup}
                                profileEnumType={plot.profileEnumType}
                                speedUnits={props.speedUnits}
                                unitsStrDepthOrHeight={props.unitsStrDepthOrHeight}
                                ucf_DepthOrHeight={props.ucf_DepthOrHeight}
                                speedUnitsStr={props.speedUnitsStr}
                                ucf_Speed={props.ucf_Speed}
                            />
                        )
                    }
                }) }
            </DataProvider>
        </div>
    );
}